import { combineReducers } from 'redux';
import referenceData from './referenceData';
import calculator from './calculator';

export const budgetBenchmarkCalculator = combineReducers({
    referenceData,
    calculator   
});
